import { registerSW } from 'virtual:pwa-register';

/** Recharge la page dès qu’un nouveau service worker prend le contrôle. */
registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    if (registration) {
      window.setInterval(() => {
        registration.update().catch(() => {});
      }, 60 * 60 * 1000);
    }
  },
});
